export const queryKeys = {
    GET_SMS_LICENSE: 'GET_SMS_LICENSE',
    POST_SMS_LICENSE: 'POST_SMS_LICENSE',
};
